import styled from 'styled-components'

const StyledEbestDividendInvestingGuide = styled.div`
  padding: var(--spacing-legacy-32) var(--spacing-legacy-20) calc(var(--spacing-legacy-50) * 2)
    var(--spacing-legacy-20);

  pre {
    white-space: pre-wrap;
    color: var(--color-ebest-grayscale-gray900);
  }

  .mainTitle {
    margin-bottom: var(--spacing-legacy-24);

    font-weight: 700;
    font-size: var(--font-size-16);
    color: #000000;
    line-height: var(--spacing-legacy-24);
    letter-spacing: -0.5px;
  }

  .introduction {
    font-weight: 400;
    font-size: var(--font-size-13);
    color: #444444;
    line-height: var(--spacing-legacy-18);
    letter-spacing: -0.5px;
  }

  .company-images {
    margin: var(--spacing-legacy-24) 0;
  }

  .topic-title {
    font-weight: 700;
    font-size: var(--font-size-16);
    color: #000000;
    line-height: var(--spacing-legacy-24);
    letter-spacing: -0.5px;

    margin-top: var(--spacing-legacy-80);
    margin-bottom: var(--spacing-legacy-16);
  }

  .topic-description {
    font-weight: 400;
    font-size: var(--font-size-13);
    color: #444444;
    line-height: var(--spacing-legacy-18);
    letter-spacing: -0.5px;
  }

  .table-image {
    margin: var(--spacing-legacy-24) 0;
  }

  .warning {
    margin-top: var(--spacing-legacy-16);

    font-weight: 400;
    font-size: var(--font-size-13);
    line-height: var(--spacing-legacy-18);
    letter-spacing: -0.5px;

    color: var(--color-ebest-grayscale-gray500);
  }
`

export default StyledEbestDividendInvestingGuide
